import React, {Component, useRef} from 'react';
import {HashRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {BlockUI} from "primereact/blockui";
import {Toast} from 'primereact/toast';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {Sidebar} from "primereact/sidebar";
import {Dropdown} from "primereact/dropdown";
import {MultiSelect} from "primereact/multiselect";
import {ConfirmDialog} from "primereact/confirmdialog";
import Favicon from 'react-favicon';
import i18next from 'i18next';
import axios from "axios";
import Cookies from "js-cookie";
import md5 from 'md5';
import {clearMercureCredentials, setMercureCredentials} from "./util/mercure";

import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/bootstrap4-light-purple/theme.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.scss';
import './assets/css/app.css';

import NavbarComponent from "./components/NavbarComponent";

import LoginPage from "./pages/LoginPage";
import RegistrationPage from "./pages/RegisterPage";
import PasswordresetRequestPage from "./pages/PasswordresetRequestPage";
import PasswordresetSetPage from "./pages/PasswordresetSetPage";
import UsersPage from "./pages/UsersPage";
import NotificationsPage from "./pages/NotificationsPage";
import NotificationPage from "./pages/NotificationPage";
import PartnerPage from "./pages/PartnerPage";
import HelpPage from "./pages/HelpPage";
import OperatorPage from "./pages/OperatorPage";
import MonologPage from "./pages/MonologPage";
import AuditlogPage from "./pages/AuditlogPage";
import RegistrationsPage from "./pages/RegistrationsPage";
import SubscriptionplanPage from "./pages/SubscriptionplanPage";
import _FM_ControlpanelPage from "./pages/_FM_ControlpanelPage";
import _FM_CalendarPage from "./pages/_FM_CalendarPage";
import _FM_AccommodationPage from "./pages/_FM_AccommodationPage";
import _FM_CategoryPage from "./pages/_FM_CategoryPage";
import _FM_UnitPage from "./pages/_FM_UnitPage";
import _FM_BerthPage from "./pages/_FM_BerthPage";
import _FM_BuilderPage from "./pages/_FM_BuilderPage";
import _FM_PaymentmethodPage from "./pages/_FM_PaymentmethodPage";
import _FM_ChanelPage from "./pages/_FM_ChanelPage";
import _FM_ServicePage from "./pages/_FM_ServicePage";
import _FM_OoounitPage from "./pages/_FM_OoounitPage";
import _FM_OooberthPage from "./pages/_FM_OooberthPage";
import _FM_ReservationPage from "./pages/_FM_ReservationPage";
import _FM_SettingsPage from "./pages/_FM_SettingsPage";
import _FM_GuestPage from "./pages/_FM_GuestPage";
import _FM_CustomerPage from "./pages/_FM_CustomerPage";
import _FM_CurrencyPage from "./pages/_FM_CurrencyPage";
import _FM_OooaccommodationPage from "./pages/_FM_OooaccommodationPage";
import _FM_PublicchekinPage from "./pages/_FM_PublicchekinPage";
import _FM_FastchekinPage from "./pages/_FM_FastchekinPage";
import _FM_GuestinforequestPage from "./pages/_FM_GuestinforequestPage";
import _FM_PricePage from "./pages/_FM_PricePage";
import _FM_PricecategoryPage from "./pages/_FM_PricecategoryPage";
import _FM_ServicepackagePage from "./pages/_FM_ServicepackagePage";
import _FM_AccommodationchecklistPage from "./pages/_FM_AccommodationchecklistPage";
import _FM_AccommodationpreparationPage from "./pages/_FM_AccommodationpreparationPage";
import _FM_FolioPage from "./pages/_FM_FolioPage";
import _FM_VatgroupPage from "./pages/_FM_VatgroupPage";
import _FM_AdminvatgroupPage from "./pages/_FM_AdminvatgroupPage";
import _FM_EzeePage from "./pages/_FM_EzeePage";
import _FM_ReceiptPage from "./pages/_FM_ReceiptPage";
import _FM_GroupPage from "./pages/_FM_GroupPage";
import ZipcodePage from "./pages/ZipcodePage";
import _FM_GirpadditionalfieldcollectionPage from "./pages/_FM_GirpadditionalfieldcollectionPage";
import ProfileFormComponent from "./components/profile/ProfileFormComponent";
import PaycenterFormComponent from "./components/paycenter/PaycenterFormComponent";
import SubscriptionFormComponent from "./components/subscription/SubscriptionFormComponent";

if (process.env.REACT_APP_BRAND === 'felhomatrac') {
  require('primereact/resources/themes/saga-orange/theme.css');
  require('./assets/css/felhomatrac.css');
}

class App extends Component {

  constructor(props) {

    super(props);
    this.toastShow = this.toastShow.bind(this);
    this.customToastStickyShow = this.customToastStickyShow.bind(this);
    this.handleGlobalKeyDown = this.handleGlobalKeyDown.bind(this);
    this.handleGlobalScroll = this.handleGlobalScroll.bind(this);
    this.preventNextSubscriptionSidebarHide = false;

    window.App = this;

    this.state = {}
  };

  componentDidMount() {
    if (Cookies.get('language') == null) {
      Cookies.set('language', 'hu', {
        expires: 365,
        secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
        sameSite: 'Strict',
        path: '/',
        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
      });
      window.App.forceUpdate()
    }
    if (Cookies.get('language') == 'hu') {
      i18next.changeLanguage('hu')
    } else if (Cookies.get('language') == 'en') {
      i18next.changeLanguage('en')
    }
    document.getElementById('root').classList.add(process.env.REACT_APP_BRAND)
    if (localStorage.getItem('adminSession') === 'true' && Cookies.get('roles') &&
      Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN')) {
      document.getElementById('body').classList.add('admin')
    }
    if (Cookies.get('theme') === 'dark') {
      document.getElementById('body').classList.add('dark-theme')
      const themeLink = document.createElement('link');
      themeLink.rel = 'stylesheet';
      themeLink.href = '/dark.css';
      document.head.appendChild(themeLink);
    }
    if (!Cookies.get('theme') || Cookies.get('theme') === 'light') {
      document.getElementById('body').classList.remove('dark-theme')
      const link = document.querySelector(`link[href="/dark.css"]`);
      if (link) {
        link.parentNode.removeChild(link);
      }
    }
    if (Cookies.get("userToken") == null) {
      clearMercureCredentials();
    }
    this.tokenRefresh()

    const handleResize = () => {
      if (window.innerWidth <= 1374) {
        this.setState({responsiveLayout: "stack"});
      } else {
        this.setState({responsiveLayout: "scroll"});
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    document.addEventListener('keydown', this.handleGlobalKeyDown);
    this.globalPointerDownListener = (e) => {
      const target = e.target;
      if (!(target instanceof Element)) {
        this.preventNextSubscriptionSidebarHide = false;
        return;
      }
      this.preventNextSubscriptionSidebarHide = !!target.closest('#toast, #toast-sticky, .p-toast');
    };
    document.addEventListener('pointerdown', this.globalPointerDownListener, true);
    window.addEventListener('scroll', this.handleGlobalScroll, true);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleGlobalKeyDown);
    document.removeEventListener('pointerdown', this.globalPointerDownListener, true);
    window.removeEventListener('scroll', this.handleGlobalScroll, true);
    if (this.destroyCustomScrollbars) {
      this.destroyCustomScrollbars();
    }
  }

  handleGlobalScroll(event) {
    const scrollTarget = event?.target;
    if (scrollTarget instanceof Element) {
      const isOverlayInternalScroll = !!scrollTarget.closest('.p-dropdown-panel, .p-multiselect-panel, .p-menu.p-menu-overlay');
      if (isOverlayInternalScroll) {
        return;
      }
    }

    const openDropdownTriggers = document.querySelectorAll('.p-dropdown .p-dropdown-trigger[aria-expanded="true"]');
    openDropdownTriggers.forEach((trigger) => {
      const dropdownRoot = trigger instanceof Element ? trigger.closest('.p-dropdown') : null;
      if (dropdownRoot instanceof HTMLElement) {
        dropdownRoot.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true}));
      }
    });

    const openSplitbuttonMenuButtons = document.querySelectorAll('.p-splitbutton .p-splitbutton-menubutton[aria-expanded="true"]');
    openSplitbuttonMenuButtons.forEach((menuButton) => {
      if (menuButton instanceof HTMLElement) {
        menuButton.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true}));
      }
    });

    const openMultiselectInputs = document.querySelectorAll('.p-multiselect input[role="listbox"][aria-expanded="true"]');
    openMultiselectInputs.forEach((input) => {
      const multiselectRoot = input instanceof Element ? input.closest('.p-multiselect') : null;
      if (multiselectRoot instanceof HTMLElement) {
        multiselectRoot.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true}));
      }
    });
  }

  handleGlobalKeyDown(e) {
    if (e.key !== 'Escape') return;

    // opcionális: ha épp input/textarea/select mezőben gépel a user, ne zárjuk be
    const tag = (e.target?.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || tag === 'select') return;

    if (window.App?.toast) window.App.toast.clear();
    //if (window.App?.toastSticky) window.App.toastSticky.clear();
  }

  tokenRefresh() {
    if (window.tokenRefreshTimeout) {
      clearInterval(window.tokenRefreshTimeout); // Előző ciklus törlése, ha futna
    }
    window.tokenRefreshTimeout = setInterval(() => {
      if (localStorage.getItem('refreshToken') && localStorage.getItem('refreshToken') !== null) {
        axios.post(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "token/refresh",
          {
            refresh_token: localStorage.getItem('refreshToken')
          },
          {
            params: {},
            headers: {
              'Authorization': 'Bearer ' + Cookies.get("userToken"),
              "Sys-name": Cookies.get("instanceId"),
              "Preferred-locale": Cookies.get("language")
            }
          })
          .then(response => {
            Cookies.set('userToken', response.data.token, {
              expires: 7,
              secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
              sameSite: 'Strict',
              path: '/',
              domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
            });
            setMercureCredentials(response.data?.mercure);
            console.log('token refreshed: ' + new Date() + ' ' + response.data.token)
          })
          .catch(error => {
            clearInterval(window.tokenRefreshTimeout)
            console.log('token refresh ERROR: ' + new Date())
          })
      }
    }, 120000)
  }

  toastShow(severity, summary, detail, life, response, url) {
    const getEffectiveZIndex = (element) => {
      let maxZIndex = 0;
      let current = element;
      while (current && current !== document.body) {
        const zIndex = Number.parseInt(window.getComputedStyle(current).zIndex, 10);
        if (!Number.isNaN(zIndex)) {
          maxZIndex = Math.max(maxZIndex, zIndex);
        }
        current = current.parentElement;
      }
      return maxZIndex;
    };
    const isElementVisible = (element) => {
      if (!element) {
        return false;
      }
      const style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
        return false;
      }
      return element.getClientRects().length > 0;
    };
    const findTopLayerFieldById = (id) => {
      const candidates = Array.from(document.querySelectorAll('[id]'))
        .filter((element) => element.id === id)
        .filter(isElementVisible);
      if (candidates.length === 0) {
        return null;
      }
      return candidates
        .map((element, domOrder) => ({element, zIndex: getEffectiveZIndex(element), domOrder}))
        .sort((a, b) => {
          if (a.zIndex !== b.zIndex) {
            return b.zIndex - a.zIndex;
          }
          return b.domOrder - a.domOrder;
        })[0].element;
    };
    const clearInjectedFieldError = (fieldElement) => {
      if (!fieldElement) {
        return;
      }
      fieldElement.classList.remove("p-invalid");
      while (fieldElement.parentElement?.nextElementSibling?.matches('small.p-error')) {
        fieldElement.parentElement.nextElementSibling.remove();
      }
    };
    const bindFieldErrorClear = (fieldElement) => {
      if (!fieldElement) {
        return;
      }
      const clear = () => clearInjectedFieldError(fieldElement);
      if (!fieldElement.dataset.backendErrorClearBound) {
        ['click', 'input', 'change'].forEach((eventName) => {
          fieldElement.addEventListener(eventName, clear);
        });
        fieldElement.dataset.backendErrorClearBound = '1';
      }
      const fieldWrapper = fieldElement.closest('.p-field') || fieldElement.parentElement?.parentElement;
      if (fieldWrapper && !fieldWrapper.dataset.backendErrorClearBound) {
        ['click', 'input', 'change'].forEach((eventName) => {
          fieldWrapper.addEventListener(eventName, clear);
        });
        fieldWrapper.dataset.backendErrorClearBound = '1';
      }
    };

    if (url === undefined) {
      url = ''
    }
    if (response && response?.data && response?.data?.message) {
      detail = response.data.message
    }
    const {t} = this.props;
    if (response && response.data && response.data.code === 401) {
      this.logout()
    } else if (response && response.status && response.status === 404) {
      window.App.toastShow('warn', t('warning'), t('item_not_found'))
      if (response.data.toString().includes("No database available for given origin")) {
        this.logout()
      }
    } else if (response && response.status && response.status === 403) {
      window.App.toastShow('warn', t('warning'), t('error_403'))
    } else if (response && response.status && response.status === 500) {
      window.App.toastShow('error', t('error'), t('error_500'))
    } else if (response && response.data && response.data.exception && response.data.exception.code === 404) {
      window.App.toastShow('warn', t('warning'), t('item_not_found'))
    } else {
      if (response && response.data && response.data.message && document.getElementById("toast").innerHTML
        && document.getElementById("toast").innerHTML.includes(response.data.message)) {
        //
      } else if (detail && document.getElementById("toast").innerHTML
        && document.getElementById("toast").innerHTML.includes(detail)) {
      } else {
        if (response && response.data && response.data.data && response.data.data.errors) {
          let index = 0
          for (const key in response.data.data.errors) {
            const fieldElement = findTopLayerFieldById(url + key)
            if (fieldElement) {
              while (fieldElement.parentElement?.nextElementSibling?.matches('small.p-error')) {
                fieldElement.parentElement.nextElementSibling.remove()
              }
              fieldElement.classList.add("p-invalid")
              bindFieldErrorClear(fieldElement)
              fieldElement.parentElement.insertAdjacentElement(
                "afterend",
                Object.assign(document.createElement('small'), {
                  className: 'p-error',
                  textContent: Array.isArray(response.data.data.errors[key])
                    ? response.data.data.errors[key].join(' ')
                    : response.data.data.errors[key]
                })
              )
            } else {
              if (index === 0) {
                detail = detail
              }
              index++;
              detail = detail + " " + response.data.data.errors[key][0].replace('.', ':') + " (" + t(key).toLowerCase() + "). "
              life = 10000
            }
          }
        }
        window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
      }
    }
  }

  customToastShow(severity, summary, detail, life) {
    window.App.toast.show({severity: severity, summary: summary, detail: detail, life: life});
  }

  customToastStickyClear() {
    window.App.toastSticky.clear()
  }

  customToastStickyShow(severity, summary, detail, link) {

    const {t} = this.props;

    const toastStickyElement = document.getElementById("toast-sticky");
    const summaryElements = toastStickyElement.querySelectorAll(".p-toast-summary");

    let matchFound = false;

    summaryElements.forEach((summaryElement) => {
      if (summaryElement.innerHTML === summary) {
        //console.log("Exact match found:", summary);
        matchFound = true;
      }
    });
    if (!matchFound) {
      window.App.toastSticky.show({
        severity: severity,
        summary: summary,
        detail: detail,
        sticky: true,
        closable: false,
        content: (props) => (
          <div className="" style={{flex: '1'}}>
            <div className="p-toast-summary p-text-bold">{props.message.summary}</div>
            <div className="">{props.message.detail}</div>
            {link &&
              <Button className="p-mt-2 p-button-sm p-button-warning"
                      severity="warning"
                      label={t('more_info')}
                      onClick={() => {
                        window.location.replace('/#' + link);
                      }}></Button>
            }
          </div>
        )
      });
    }
  }

  changeLanguage(language) {
    if (language == 'hu') {
      Cookies.set('language', 'hu', {
        expires: 365,
        secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
        sameSite: 'Strict',
        path: '/',
        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
      });
      i18next.changeLanguage('hu')
    } else if (language == 'en') {
      Cookies.set('language', 'en', {
        expires: 365,
        secure: JSON.parse(process.env.REACT_APP_APP_COOKIE_SECURE.toLowerCase()),
        sameSite: 'Strict',
        path: '/',
        domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
      });
      i18next.changeLanguage('en')
    }
  }

  urlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      vars[key] = value;
    });
    return vars;
  }

  getTranslatedLabel(label) {
    const {t} = this.props;
    const capitalizeFirstLetter = (string = '') => string
      ? string.charAt(0).toUpperCase() + string.slice(1)
      : '';
    return (capitalizeFirstLetter(t(label.toLowerCase()?.replaceAll(' ', '_'))))
  }

  transformQueryParams(lazyParams) {
    let query = '?'
    if (lazyParams.sortField) {
      query += 'sort=' + lazyParams.sortField.toLowerCase()
    }
    if (lazyParams.sortOrder) {
      if (lazyParams.sortOrder == 1) {
        query += '&direction=asc'
      }
      if (lazyParams.sortOrder == -1) {
        query += '&direction=desc'
      }
    }
    if (lazyParams.filters) {
      delete lazyParams.genericSearch
      Object.entries(lazyParams.filters).map(function (filter, index) {
        if (filter[1]?.constraints[0]?.value !== null) {
          //{{protocol}}://{{domain}}/api/service?search[available_for][operator]=in&search[available_for][value][]=customer&search[available_for][value][]=both
          //{{protocol}}://{{domain}}/api/service?search[available_for][operator]=!=&search[available_for][value]=customer
          if (filter[1].constraints[0].matchMode === 'like') {
            query += '&search[' + filter[0].toLowerCase() + '][operator]=' + filter[1].constraints[0].matchMode + '&search[' + filter[0].toLowerCase()
              + '][value]=*' + filter[1].constraints[0].value + '*'
          } else {
            query += '&search[' + filter[0].toLowerCase() + '][operator]=' + filter[1].constraints[0].matchMode + '&search[' + filter[0].toLowerCase()
              + '][value]=' + filter[1].constraints[0].value
          }

        }
      })
    }
    if (lazyParams.is_active === 1 || lazyParams.is_active === 0) {
      query += '&search[is_active]=' + lazyParams.is_active
    }
    if (lazyParams.search) {
      query += '&search=' + lazyParams.search
    }
    if (lazyParams.genericSearch && !lazyParams.filters) {
      query += '&search[free_text]=' + lazyParams.genericSearch
    }
    if (lazyParams.rows) {
      query += '&item_per_page=' + lazyParams.rows
    }
    if (lazyParams.page) {
      query += '&page=' + Number(lazyParams.page + 1)
    }
    return (query)
  }

  zipCode(code, callback) {
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "public/hungarian-zip-code/" + code,
      params: {},
      headers: {
        "Sys-name": Cookies.get("instanceId") || window.location.href.split("//")[1].split(".")[0].replaceAll('-', '_'),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        if (response.data.data && response.data.data[0]) {
          if (callback) callback(response.data.data[0]);
        }
      })
      .catch(error => {

      })
  }

  help(url) {
    if (!document.body.classList.contains('admin')) {
      const {t} = this.props;
      let _global = []
      let _site = []
      let _field = []
      let _ebox = []
      let _sbox = []
      let _tab = []
      let _section = []
      axios({
        method: 'post',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "help-badge",
        data: {
          url: url
        },
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          const items = response?.data?.data?.items;
          const helpItems = Array.isArray(items) ? items : Object.values(items || {});
          if (helpItems.length > 0) {
            helpItems.filter(Boolean).forEach((help) => {
              if (help.type === 'GLOBAL') {
                _global.push({
                  type: help.type,
                  position: help.position,
                  level: help.level,
                  message: help.message,
                  locale: help.locale,
                  url: help.url,
                })
              }
              if (help.type === 'ON_SITE') {
                _site.push({
                  type: help.type,
                  position: help.position,
                  level: help.level,
                  message: help.message,
                  locale: help.locale,
                  url: help.url,
                })
              }
              if (help.type === 'ON_FIELD') {
                _field.push({
                  type: help.type,
                  level: help.level,
                  field: help.form_field,
                  message: help.message,
                  locale: help.locale,
                  url: help.url,
                })
              }
              if (help.type === 'ON_EDIT_BOX') {
                _ebox.push({
                  type: help.type,
                  level: help.level,
                  message: help.message,
                  locale: help.locale,
                  url: help.url,
                })
              }
              if (help.type === 'ON_SHOW_BOX') {
                _sbox.push({
                  type: help.type,
                  level: help.level,
                  message: help.message,
                  locale: help.locale,
                  url: help.url,
                })
              }
              if (help.type === 'TAB') {
                _tab.push({
                  type: help.type,
                  level: help.level,
                  message: help.message,
                  locale: help.locale,
                  url: help.url,
                  tab_number: help.tab_number,
                })
              }
              if (help.type === 'SECTION') {
                _section.push({
                  type: help.type,
                  level: help.level,
                  message: help.message,
                  locale: help.locale,
                  url: help.url,
                  tab_number: help.tab_number,
                  section_number: help.section_number,
                })
              }
            });
            window.App.setState(prevState => ({
              help: {
                ...prevState.help,
                global: _global,
                site: _site,
                field: _field,
                edit_box: _ebox,
                show_box: _sbox,
                tab: _tab,
                section: _section,
              }
            }))
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }
  }

  formLock(entityClass, entityId) {
    const lockDelay = 1500; // Időzítés lock fenntartására
    const unlockDelay = 8000; // Időzítés unlock hívás késleltetésére

    window.App.setState({
      formLocked: entityClass,
      formEntityLocked: entityId
    });

    if (entityClass === window.App.state.formLocked && entityId === window.App.state.formEntityLocked) {
      clearTimeout(window.intervalLock); // Újrahívás esetén reseteljük az unlock időzítőjét
      window.intervalLock = setTimeout(() => {
        this.formUnlock(entityClass, entityId);
      }, unlockDelay);
      return;
    }

    axios({
      method: 'post',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "lock",
      data: {
        entity_class: entityClass,
        entity_id: entityId
      },
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        // Beállítjuk az unlock időzítőt
        clearTimeout(window.intervalLock); // Korábbi időzítőt töröljük
        window.intervalLock = setTimeout(() => {
          this.formUnlock(entityClass, entityId);
        }, unlockDelay);
        //relock
        window.intervalUnLock = setInterval(() => {
          axios({
            method: 'post',
            url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "lock",
            data: {
              entity_class: entityClass,
              entity_id: entityId
            },
            params: {},
            headers: {
              'Authorization': 'Bearer ' + Cookies.get("userToken"),
              "Sys-name": Cookies.get("instanceId"),
              "Preferred-locale": Cookies.get("language")
            }
          })
            .then(response => {

            })
            .catch(error => {

            })
        }, 60000)
      })
      .catch(error => {
      });
  }

  formUnlock(entityClass, entityId) {
    window.App.setState({
      formLocked: '',
      formEntityLocked: ''
    });
    axios({
      method: 'post',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "unlock",
      data: {
        entity_class: entityClass,
        entity_id: entityId
      },
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
      .then(response => {
        clearInterval(window.intervalUnLock);
      })
      .catch(error => {
      });
  }

  // formLock(entityClass, entityId) {
  //   window.App.setState({
  //     formLocked: entityClass,
  //     formEntityLocked: entityId
  //   })
  //   if (entityClass !== window.App.state.formLocked && entityId !== window.App.state.formEntityLocked) {
  //     //lock
  //     axios({
  //       method: 'post',
  //       url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "lock",
  //       data: {
  //         entity_class: entityClass,
  //         entity_id: entityId
  //       },
  //       params: {},
  //       headers: {
  //         'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //         "Sys-name": Cookies.get("instanceId"),
  //         "Preferred-locale": Cookies.get("language")
  //       }
  //     })
  //       .then(response => {
  //         //relock
  //         window.intervalUnLock = setInterval(() => {
  //           axios({
  //             method: 'post',
  //             url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "lock",
  //             data: {
  //               entity_class: entityClass,
  //               entity_id: entityId
  //             },
  //             params: {},
  //             headers: {
  //               'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //               "Sys-name": Cookies.get("instanceId"),
  //               "Preferred-locale": Cookies.get("language")
  //             }
  //           })
  //             .then(response => {
  //
  //             })
  //             .catch(error => {
  //
  //             })
  //         }, 60000)
  //       })
  //       .catch(error => {
  //
  //       })
  //   }
  //   clearInterval(window.intervalLock)
  //   window.intervalLock = setTimeout(function () {
  //     window.App.setState({
  //       formLocked: '',
  //       formEntityLocked: ''
  //     })
  //     //unlock
  //     axios({
  //       method: 'post',
  //       url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "unlock",
  //       data: {
  //         entity_class: entityClass,
  //         entity_id: entityId
  //       },
  //       params: {},
  //       headers: {
  //         'Authorization': 'Bearer ' + Cookies.get("userToken"),
  //         "Sys-name": Cookies.get("instanceId"),
  //         "Preferred-locale": Cookies.get("language")
  //       }
  //     })
  //       .then(response => {
  //         clearInterval(window.intervalUnLock)
  //
  //       })
  //       .catch(error => {
  //
  //       })
  //   }, 1500)
  // }

  generateHexFromNumber(number) {
    const input = String(number ?? ''); // null/undefined esetén is biztonságos
    const hash = md5(input); // Hash generálás
    return hash.slice(0, 6); // Az első 6 karakter
  }

  delete(url, id) {
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + url + "/" + id,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + Cookies.get("userToken"),
        "Sys-name": Cookies.get("instanceId"),
        "Preferred-locale": Cookies.get("language")
      }
    })
  }

  logout() {
    clearMercureCredentials();
    Cookies.remove('userToken', {
      path: '/',
      domain: process.env.REACT_APP_APP_COOKIE_DOMAIN
    });
    clearTimeout(window.tokenRefreshTimeout)
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('adminSession')
    window.location.replace('/#/');
    window.App.forceUpdate()
    window.location.reload()
  }

  render() {
    return (
      <Router>
        <div className={process.env.REACT_APP_BRAND} id="app">
          <Favicon url={require("." + process.env.REACT_APP_FAVICON_FILE)}/>
          <Toast ref={(el) => this.toast = el} position="bottom-right" id={"toast"}/>
          <Toast ref={(el) => this.toastSticky = el} position="bottom-left" id={"toast-sticky"}/>
          {Cookies.get("userToken") == null ? (
            <Routes>
              <Route path="*" element={<LoginPage/>} exact/>
              {!Cookies.get("subdomain") &&
                <Route path="/registration" element={<RegistrationPage/>}/>
              }
              <Route path="/password-reset" element={<PasswordresetRequestPage/>}/>
              <Route path="/password-set" element={<PasswordresetSetPage/>}/>
              {process.env.REACT_APP_BRAND === 'felhomatrac' &&
                <>
                  <Route path="/public-checkin" element={<_FM_PublicchekinPage/>}/>
                  <Route path="/fast-checkin" element={<_FM_FastchekinPage/>}/>
                </>
              }
            </Routes>
          ) : (
            <>
              <BlockUI blocked={this.state.loading} className="blocked-ui-overlay"
                       template={<div className="blocked-ui-message"><i
                         className="pi pi-exclamation-triangle blocked-ui-message-icon"
                         aria-hidden="true"></i>{this.props.t("module_editing_after_save_only")}</div>}>
                <NavbarComponent/>
                <div id="page">
                  <Routes>
                    <Route path="/user/:action?/:id?" element={<UsersPage/>}/>
                    <Route path="/notifications" element={<NotificationsPage/>}/>
                    {/*<Route path="/profile/:action?/:id?" element={<ProfilePage/>}/>*/}
                    <Route path="/partner/:action?/:id?" element={<PartnerPage/>}/>
                    <Route path="/operator/:action?/:id?" element={<OperatorPage/>}/>
                    {/*<Route path="/paycenter-online-payment/:action?/:id?" element={<PaycenterPage/>}/>*/}
                    {/*<Route path="/subscription" element={<SubscriptionPage/>}/>*/}
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/help" element={<HelpPage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/zipcode" element={<ZipcodePage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/monolog" element={<MonologPage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/auditlog/:action?/:id?" element={<AuditlogPage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/registrations" element={<RegistrationsPage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/subscriptionplan" element={<SubscriptionplanPage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/notification/:action?" element={<NotificationPage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/girp-additional-field-collection/:action?/:id?"
                             element={<_FM_GirpadditionalfieldcollectionPage/>}/>
                    }
                    {Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                      <Route path="/admin-vatgroup/:action?/:id?" element={<_FM_AdminvatgroupPage/>}/>
                    }
                    <Route path="*" element={<Navigate to="/control-panel" replace/>}/>
                    <Route path="/control-panel/:entity?/:action?/:id?" element={<_FM_ControlpanelPage/>}/>
                    <Route path="/calendar/:action?/:id?" element={<_FM_CalendarPage/>}/>
                    <Route path="/reservation/:action?/:id?"
                           element={<_FM_ReservationPage/>}/>
                    <Route path="/service/:action?/:id?" element={<_FM_ServicePage/>}/>
                    <Route path="/service-package/:action?/:id?" element={<_FM_ServicepackagePage/>}/>
                    <Route path="/guest/:action?/:id?" element={<_FM_GuestPage/>}/>
                    <Route path="/customer/:action?/:id?" element={<_FM_CustomerPage/>}/>
                    <Route path="/builder/:accommodationId?" element={<_FM_BuilderPage/>}/>
                    <Route path="/category/:action?/:id?" element={<_FM_CategoryPage/>}/>
                    <Route path="/unit/:action?/:id?" element={<_FM_UnitPage/>}/>
                    <Route path="/berth/:action?/:id?" element={<_FM_BerthPage/>}/>
                    <Route path="/ooounit/:action?/:id?" element={<_FM_OoounitPage/>}/>
                    <Route path="/oooberth/:action?/:id?" element={<_FM_OooberthPage/>}/>
                    <Route path="/payment-method/:action?/:id?" element={<_FM_PaymentmethodPage/>}/>
                    <Route path="/currency/:action?/:id?" element={<_FM_CurrencyPage/>}/>
                    <Route path="/vat-group/:action?/:id?" element={<_FM_VatgroupPage/>}/>
                    <Route path="/channel/:action?/:id?" element={<_FM_ChanelPage/>}/>
                    <Route path="/accommodation/:action?/:id?" element={<_FM_AccommodationPage/>}/>
                    <Route path="/oooaccommodation/:action?/:id?"
                           element={<_FM_OooaccommodationPage/>}/>
                    <Route path="/settings" element={<_FM_SettingsPage/>}/>
                    <Route path="/guest-information-request-page/:action?/:id?"
                           element={<_FM_GuestinforequestPage/>}/>
                    <Route path="/public-checkin" element={<_FM_PublicchekinPage/>}/>
                    <Route path="/fast-checkin" element={<_FM_FastchekinPage/>}/>
                    <Route path="/price/:date?/:resource?/:action?/:id?" element={<_FM_PricePage/>}/>
                    <Route path="/price-category/:action?/:id?" element={<_FM_PricecategoryPage/>}/>
                    <Route path="/folio/:action?/:id?" element={<_FM_FolioPage/>}/>
                    <Route path="/receipt/:action?/:id?" element={<_FM_ReceiptPage/>}/>
                    <Route path="/accommodation-readiness-checklist/:action?/:id?"
                           element={<_FM_AccommodationchecklistPage/>}/>
                    <Route path="/accommodation-preparation/:action?/:id?"
                           element={<_FM_AccommodationpreparationPage/>}/>
                    <Route path="/ezee/:id?" element={<_FM_EzeePage/>}/>
                    <Route path="/group/:action?/:id?" element={<_FM_GroupPage/>}/>
                  </Routes>
                </div>
              </BlockUI>
              {(localStorage.getItem('adminSession') && localStorage.getItem('adminSession') === 'true')
                && Cookies.get('roles') && Cookies.get('roles').toString().includes('ROLE_SUPER_ADMIN') &&
                <>
                  <Button type="button" className="p-button-danger" icon={"pi pi-code"} id={"debugButton"}
                          onClick={() => {
                            window.App.setState({debug: true})
                          }}/>
                  <Dialog header="Debug box" visible={window.App.state.debug} position={"bottom"}
                          style={{width: '50vw'}}
                          onHide={() => {
                            window.App.setState({debug: false})
                          }} footer={false} modal={false} resizable={false}>
                    <div className={"p-grid"}>
                      <div className={"p-col-6"}>
                      <span className={"p-text-bold"}>
                        API Host:&nbsp;
                      </span>
                        {process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST}
                      </div>
                      <div className={"p-col-6"}>
                      <span className={"p-text-bold"}>
                        Node env:&nbsp;
                      </span>
                        {process.env.NODE_ENV}
                      </div>
                      <div className={"p-col-6"}>
                      <span className={"p-text-bold"}>
                        Brand:&nbsp;
                      </span>
                        {process.env.REACT_APP_BRAND}
                      </div>
                      <div className={"p-col-6"}>
                      <span className={"p-text-bold"}>
                        Frontend version:&nbsp;
                      </span>
                        {process.env.REACT_APP_VERSION}
                      </div>
                      <hr/>
                      <div className={"p-col-12"}>
                      <span className={"p-text-bold"}>
                        APP storage:&nbsp;
                      </span>
                        <pre>
                      {JSON.stringify(localStorage, null, "\t")}
                      </pre>
                      </div>
                    </div>
                  </Dialog>
                </>
              }
              <Sidebar position="right" visible={window.App.state.sidebarProfileForm} closeOnEscape={true}
                       dismissable={true} modal={false}
                       style={{width: '780px'}}
                       onHide={() => {
                         window.App.setState({sidebarProfileForm: false})
                       }}>
                <ProfileFormComponent/>
              </Sidebar>
              <Sidebar position="right" visible={window.App.state.sidebarPaycenterForm} closeOnEscape={true}
                       dismissable={true} modal={false}
                       style={{width: '780px'}}
                       onHide={() => {
                         window.App.setState({sidebarPaycenterForm: false})
                       }}>
                <PaycenterFormComponent/>
              </Sidebar>
              <Sidebar position="right" visible={window.App.state.sidebarSubscriptionForm} closeOnEscape={true}
                       dismissable={true} modal={false}
                       style={{width: '780px'}}
                       onHide={() => {
                         if (window.App.preventNextSubscriptionSidebarHide) {
                           window.App.preventNextSubscriptionSidebarHide = false;
                           return;
                         }
                         if (window.App.state.subscriptionPaymentDialogVisible) {
                           return;
                         }
                         if (window.App.state.subscriptionConfirmDialogVisible) {
                           return;
                         }
                         window.App.setState({sidebarSubscriptionForm: false})
                       }}>
                <SubscriptionFormComponent/>
              </Sidebar>
            </>
          )}
        </div>
      </Router>
    );
  }
}

export default withTranslation('common')(App);
